import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../config/routes';
import { useMetadata } from '../utils/metadata';

function Home() {
  useMetadata({
    title: 'Free Online Developer Tools',
    description: 'Free online tools for developers and network administrators. DNS lookup, ping testing, CIDR calculators, email tools, and more. No registration required.',
    keywords: ['developer tools', 'network tools', 'online tools', 'free tools', 'dns tools', 'ping test', 'cidr calculator', 'email tools', 'proxyscrape tools']
  });
  const ToolCard = ({ tool }) => {
    const IconComponent = tool.icon;
    
    const content = (
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <IconComponent className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-medium text-gray-900">{tool.title}</h3>
          <p className="mt-2 text-gray-500">{tool.description}</p>
        </div>
      </div>
    );

    if (tool.isExternal) {
      return (
        <a
          href={tool.link}
          className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
        >
          {content}
        </a>
      );
    }

    return (
      <Link
        to={tool.link}
        className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
      >
        {content}
      </Link>
    );
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Online Tools
        </h1>
        <p className="text-xl text-gray-600">
          Free network, development, and utility tools for everyone
        </p>
      </div>

      {categories.map((category) => (
        <div key={category.id} className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">{category.name}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {category.tools.map((tool) => (
              <ToolCard key={tool.id} tool={tool} />
            ))}
          </div>
        </div>
      ))}

      <div className="mt-16 bg-white rounded-lg shadow-sm p-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">About These Tools</h2>
        <div className="prose prose-indigo max-w-none">
          <p className="text-gray-600 mb-4">
            As a leading provider of proxy services, ProxyScrape has always focused on delivering high-quality proxy solutions. 
            Over time, we noticed our users frequently needed additional tools for tasks like checking proxy connections, 
            testing network connectivity, and handling various data formats.
          </p>
          <p className="text-gray-600 mb-4">
            That's why we've created this comprehensive suite of free online tools. Whether you're working with proxies, 
            testing network connections, or need help with common development tasks, these tools are designed to make 
            your work easier and more efficient.
          </p>
          <p className="text-gray-600">
            All tools are completely free to use, with no registration required. They work directly in your browser 
            and are regularly updated to ensure reliability and security.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
